import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
// MUI
import { Box, Divider, Stack, Typography } from "@mui/material";
// Components
import BirthdaysList from "./BirthdaysList";
// Types
import { RootState } from "@/redux/store";
// Icons
import BirthDayCake from "@/assets/icons/dashboard/birthdays-of-the-month.svg";
// Api
import { getUsersByMonthOfBirthDay } from "../../api/queries";
import clsx from "clsx";

export default function BirthdaysOfMonth() {
	const [{ title, sayHP }, setTitles] = useState({ title: "Birthdays of the Month", sayHP: "Happy Birthday!" });

	const location = useSelector((state: RootState) => state.location.location);

	const { data, isPending } = useQuery({
		queryKey: ["usersByMonthOfBirthDay", location?.locationId],
		queryFn: async () => {
			if (!location?.locationId) {
				throw new Error("Cant fetch data without locationId");
			}
			const response = await getUsersByMonthOfBirthDay(location?.locationId);
			if (response?.length === 0) {
				setTitles({
					title: "No Cake this Month",
					sayHP: "",
				});
			} else {
				setTitles({
					title: "Birthdays of the Month",
					sayHP: "Happy Birthday!",
				});
			}

			return response;
		},
		enabled: !!location?.locationId,
	});

	return (
		<>
			<Stack direction="row" justifyContent="space-between" alignItems="center" className="mb-[10px]">
				<Box>
					<Typography className="!font-montserrat !font-medium !text-default !text-[1.3rem]">{title}</Typography>
					<Typography className="!font-montserrat !font-medium !text-neutral-gray">{sayHP}</Typography>
				</Box>
				<img className="w-[23px] mr-[10px]" src={BirthDayCake} alt="" />
			</Stack>
			<Divider className="!mb-[10px] w-full" />
			<Box
				className={clsx("max-h-[242px]", {
					"overflow-y-auto w-[420px] pr-[5px]": Number(data?.length) > 10,
				})}
			>
				<BirthdaysList data={data ?? []} isPending={isPending} />
			</Box>
		</>
	);
}
